import type { TFunction } from 'i18next';
import type { ReportPreviewProfile } from 'api/analytics-reports/types';
import { buildPlatformReportPreviewPages } from './buildPlatformReportPreviewPages';
import { countOverviewReportPreviewPages } from './buildOverviewReportPreviewPages';
import { splitPerformanceMetricsByChartSupport } from './getPerformanceChartConfig';
import { resolvePreviewContentPosts } from './resolvePreviewContentPosts';
import { isReportContentPostsEnabled } from '../constants/reportContentPostSettings';
import { resolveReportPreviewProfileHeaderMeta } from './resolveReportPreviewProfileHeaderMeta';
import { isOverviewPreviewProfile } from './resolveReportPreviewOverviewSection';

export function countPreviewPagesForProfile(
  profile: ReportPreviewProfile,
  t: TFunction,
): number {
  if (isOverviewPreviewProfile(profile)) {
    return countOverviewReportPreviewPages(profile.type === 'general');
  }

  const performanceSection = profile.sections.find(
    (section) => section.kind === 'performance',
  );
  const contentSection = profile.sections.find(
    (section) => section.kind === 'content',
  );

  const { chartMetrics, tileMetrics } = splitPerformanceMetricsByChartSupport(
    performanceSection?.kind === 'performance'
      ? performanceSection.metrics
      : [],
  );

  const contentPosts =
    contentSection?.kind === 'content'
      ? resolvePreviewContentPosts(contentSection.data)
      : [];
  const includePosts =
    contentSection?.kind === 'content' &&
    isReportContentPostsEnabled({
      content_post_count: contentSection.post_count,
    });

  const profileHeaderMeta = resolveReportPreviewProfileHeaderMeta(profile, t);

  return buildPlatformReportPreviewPages({
    pageType: profileHeaderMeta.pageType,
    cardType: profile.type,
    chartMetrics,
    performanceTileMetrics: tileMetrics,
    performanceMetrics:
      performanceSection?.kind === 'performance'
        ? performanceSection.metrics
        : [],
    contentMetrics:
      contentSection?.kind === 'content' ? contentSection.metrics : [],
    posts: contentPosts,
    includePosts,
    performanceNote:
      performanceSection?.kind === 'performance'
        ? performanceSection.note
        : undefined,
    contentNote:
      contentSection?.kind === 'content' ? contentSection.note : undefined,
  }).length;
}
